import styled, { CSSObject } from '@emotion/styled'
import { CommonTitle, VisibileToggleDiv } from '../common'

type Props = {
  title: string
  onChange?: () => void
  isChangeButtonVisible?: boolean
}

const CheckoutFormTitle = ({
  title,
  onChange,
  isChangeButtonVisible = true
}: Props) => {
  return (
    <TitleContainer>
      <CommonTitle>{title}</CommonTitle>
      {!!onChange && (
        <VisibileToggleDiv isVisible={isChangeButtonVisible}>
          <ChangeText
            data-testid='personal-details-change-button'
            onClick={onChange}
          >
            Change
          </ChangeText>
        </VisibileToggleDiv>
      )}
    </TitleContainer>
  )
}

const TitleContainer = styled.span(
  (): CSSObject => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '20px'
  })
)

const ChangeText = styled.span(
  ({ theme }): CSSObject => ({
    textDecoration: 'underline',
    fontWeight: 500,
    fontSize: '14px',
    paddingLeft: '8px',
    cursor: 'pointer'
  })
)

export default CheckoutFormTitle
